import axios, { AxiosRequestConfig } from 'axios';
import localStorageService from '../services/localStorageService';
import { auth } from '../firebase';

export const getAccessToken = async () => {
  const accessToken = await auth()?.currentUser?.getIdToken();
  
  if (accessToken && accessToken !== localStorageService.getAccessToken()) {
    localStorageService.setAccessToken(accessToken);
  }
  return accessToken;
}

export const apiAxios = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'content-type': 'application/json',
    ...(localStorageService.getAccessToken() && {'Authorization': 'Bearer ' + localStorageService.getAccessToken()})
  },
});

const get = (url: string) => requestApi('get', url);
const post = (url: string, requestConfig: any = {}) => requestApi('post', url, requestConfig);
const put = (url: string, requestConfig: any = {}) => requestApi('put', url, requestConfig);
const deleteApi = (url: string, requestConfig: any = {}) => requestApi('delete', url, requestConfig);

const requestApi = async (method: string, url: string, requestConfig: any = {}) => {
  try {
    const accessToken = localStorageService.getAccessToken();
    let config: any = { method: method, url: requestConfig?.data?.otherUrl
        ? requestConfig?.data?.otherUrl : `${process.env.REACT_APP_API_URL}/${url}`
    };
    
    const updatedConfig = requestConfig;
    
    delete updatedConfig?.data?.otherUrl
    
    if(!!accessToken) {
      config = {...config, headers: {'Authorization': 'Bearer ' + accessToken}};
    }
    
    config = {...config, ...updatedConfig};
    
    return await request(config);
  } catch (e: any) {
    console.log(`requestApi: url: ${url}; requestConfig: ${JSON.stringify(requestConfig)},
        method: ${method}; error: ${e}; response data: ${JSON.stringify(e.response?.data)}`);
    
    throw e;
  }
};

const request = (requestConfig: AxiosRequestConfig) => axios.request(requestConfig);

axios.interceptors.response.use(
  response => response,
  async error => {
    if(error.response?.data.statusCode === 401 || error.response?.data.message === "Forbidden") {
      localStorageService.clearAccessToken();
      window.location.replace(`${window.location.origin}/sign-in`);
    }
    
    throw error;
  }
);

axios.interceptors.request.use(
  async config => {
    await getAccessToken();
    return config;
  },
  error => {
    Promise.reject(error.response || error.message);
  }
);

export default {
  get,
  put,
  post,
  deleteApi
}


